import React, { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SITE } from "@/data/site";
import { toast } from "sonner";
import { Lock } from "lucide-react";

const AdminLogin = () => {
    const { user, login } = useAuth();
    const nav = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [submitting, setSubmitting] = useState(false);

    if (user) {
        const to = location.state?.from?.pathname || "/admin";
        return <Navigate to={to} replace />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await login(email, password);
            toast.success("Sessão iniciada com sucesso");
            nav("/admin");
        } catch (err) {
            const detail = err.response?.data?.detail;
            toast.error(
                typeof detail === "string"
                    ? detail
                    : "Não foi possível iniciar sessão",
            );
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            className="min-h-screen flex items-center justify-center p-6"
            style={{
                background:
                    "linear-gradient(135deg, var(--acd-navy-950) 0%, var(--acd-navy-800) 100%)",
            }}
            data-testid="admin-login-page"
        >
            <div className="w-full max-w-md">
                <div className="flex justify-center mb-8">
                    <img
                        src={SITE.logoUrl}
                        alt="ACD Advogados"
                        className="h-20 bg-white rounded-xl p-3"
                    />
                </div>
                <div className="bg-white rounded-2xl shadow-2xl p-8">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[var(--acd-blue-600)] to-[var(--acd-orange)] text-white flex items-center justify-center">
                            <Lock size={20} />
                        </div>
                        <div>
                            <h1 className="text-xl font-bold text-[var(--acd-navy-900)]">
                                Área Administrativa
                            </h1>
                            <p className="text-sm text-[color:var(--acd-muted)]">
                                Acesso restrito
                            </p>
                        </div>
                    </div>
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label className="acd-label">Email</label>
                            <input
                                type="email"
                                required
                                className="acd-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                data-testid="admin-login-email"
                                autoComplete="email"
                            />
                        </div>
                        <div>
                            <label className="acd-label">Password</label>
                            <input
                                type="password"
                                required
                                className="acd-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                data-testid="admin-login-password"
                                autoComplete="current-password"
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={submitting}
                            className="acd-btn-gradient w-full justify-center"
                            data-testid="admin-login-submit"
                        >
                            {submitting ? "A entrar..." : "Entrar"}
                        </button>
                    </form>
                </div>
                <p className="text-center text-white/60 text-xs mt-6">
                    © {new Date().getFullYear()} ACD Advogados — Área
                    Administrativa
                </p>
            </div>
        </div>
    );
};

export default AdminLogin;
